<div class="p-8 flex flex-col items-center gap-6 text-center bg-lGray900 rounded-[24px]">
  <img
    [src]="iconPath"
    [alt]="safeAlt"
    class="h-64 w-auto object-contain"
  />

  <div class="flex flex-col gap-2">
    <h2 class="text-2xl font-semibold text-color">{{ title }}</h2>
    <p class="text-sm subtext-color leading-relaxed">{{ subtitle }}</p>
  </div>
</div>

<div class="flex justify-center mt-10">
  <button
    lButton
    [bType]="buttonTypeEnum.PRIMARY"
    [bSize]="buttonSizeEnum.MEDIUM"
    [bRadius]="buttonRadiusEnum.LARGE"
    (click)="close()"
  >
    {{ primaryButtonLabel }}
  </button>
</div>
